/**
 * Foundation/Core — Suite Shell constants
 *
 * Etichette generiche condivise da tutti i Product Pack della Gruppo Impresa Suite:
 * - Etichette di sezione della sidebar
 * - Etichette dei ruoli RBAC (label-only, chiavi interne stabili)
 *
 * Nessun riferimento a dominio applicativo (presenze, fatturazione, studio, ...).
 */

// Etichette di sezione utilizzate da SidebarLinks per raggruppare le voci di menu.
// Ogni Product Pack puo' associare le proprie voci di menu ad una di queste sezioni.
export const SECTION_LABELS = {
  operativita: "Operatività",
  pianificazione: "Pianificazione e controlli",
  admin: "Amministrazione",
  advanced: "Strumenti avanzati",
};

// Etichette user-facing dei ruoli RBAC della Suite (v0.99.88 · label-only).
// Le chiavi interne restano stabili — modificare solo i valori (traduzioni/rinomine).
export const ROLE_LABELS = {
  admin: "Root",
  super_admin: "Root",
  consulente: "Consulente",
  studio_operator: "Collaboratore",
  client: "Amministratore azienda",
  company_admin: "Amministratore azienda",
  company_responsible: "Responsabile azienda",
  responsabile: "Responsabile azienda",
  employee: "Dipendente",
  external_consultant: "Professionista delegato",
};
